import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces'
import type { IConsumoMetrica, IConsumoResponse } from '@/modules/Analitica/interfaces/IConsumo'

export class AnaliticaService extends BaseService<unknown> {
  constructor () {
    super({ baseUrl: 'auditoria/consumo/' })
  }

  async getMetricas (params?: { fechaInicio?: string; fechaFin?: string }): Promise<AxiosResponse<IResponseApi<IConsumoResponse>>> {
    return this.http
      .get<IResponseApi<IConsumoResponse>>('/metricas', { params })
      .catch(this.errorHandle)
  }
}
